import { render, staticRenderFns } from "./AllocatedProfitsChart.vue?vue&type=template&id=05238dda&scoped=true&"
import script from "./AllocatedProfitsChart.vue?vue&type=script&lang=js&"
export * from "./AllocatedProfitsChart.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedProfitsChart.vue?vue&type=style&index=0&id=05238dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05238dda",
  null
  
)

export default component.exports